import { render, staticRenderFns } from "./EventManageView.vue?vue&type=template&id=99aa2ec8"
import script from "./EventManageView.vue?vue&type=script&lang=js"
export * from "./EventManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports